const SupportActions = {
    UPDATE: 'UPDATE_SUPPORT_TICKETS',
    CLEAR: "CLEAR_DATA",
    CHAT_STATUS: "CHAT_STATUS",
    T_STATUS: "TICKET_STATUS",
    UPDATE_NAV: "UPDATE_NAV"
}

export default SupportActions;